import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const departmentTagKeys = createQueryKeyStore({
  departmentTag: {
    list: null,
  },
});
